import { render } from "./EventsSwiper.vue?vue&type=template&id=53327efa"
import script from "./EventsSwiper.vue?vue&type=script&lang=js"
export * from "./EventsSwiper.vue?vue&type=script&lang=js"

import "./EventsSwiper.vue?vue&type=style&index=0&id=53327efa&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__